import React, {useEffect, useState} from 'react';
import './ProMinusPopup.scss';
import {Button, Input, message, Modal, notification} from 'antd';
import {login, logoutApp, setActiveModal} from 'store/global/actions';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {MODALS, TIMEOUT, UPGRADE_PLAN_FORM_LINK} from 'utils/constants';
import GlobalApi from 'services/Global';
import {getWelcomeText} from 'utils/getDate';
import closeIcon from '../../assets/images/cancel.svg';
import loginIcon from '../../assets/images/view-graph-arrow.svg';
import {storage} from 'services/config/storage';

export const ProMinusPopup = (props) => {
    const [isVisible, setVisible] = useState(false);
    const [emailId, setEmailId] = useState('');
    const [loading, setLoading] = useState(false);
    const [pwdMode, setPwdMode] = useState(false);
    const [password, setPassword] = useState('');
    const {user, activeModal} = useSelector(({global}) => global);
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const logincode = params.get('logincode');
        const justLoggedIn = localStorage.getItem('justLoggedIn');
        if (logincode && justLoggedIn === 'true') {
            setPwdMode(false);
            dispatch(setActiveModal(MODALS.PRO_MINUS));
        }
    }, [location.search]);
    useEffect(() => {
        setVisible(
            activeModal === MODALS.PRO_MINUS ||
                activeModal === MODALS.PRO_MINUS_PWD,
        );
        setPwdMode(activeModal === MODALS.PRO_MINUS_PWD);
    }, [activeModal]);
    const getFromLocation = (obj) => {
        let loc = {};
        let iterationCount = 0;
        let parentKey = '';
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === 'object') {
                //if nested object is present, recursively call the function with that nested object
                getFromLocation(obj[key]);
                parentKey = key;
                ++iterationCount;
            } else loc = obj[parentKey];
        });
        if (iterationCount === 0) return obj;
        //if no nested object is present, return the original
        else return loc;
    };
    const loginWithCode = async (e) => {
        e.preventDefault();
        if (emailId) {
            setLoading(true);
            //TODO: @vineet check this piece of code
            let from = getFromLocation(props.location);
            if (from.pathname?.includes('/etf'))
                from = {
                    ...from,
                    search: from.search?.replace('&logincode=true', ''),
                };
            const auth = await dispatch(login({emailId}));
            if (!auth?.login) {
                props.history.push({
                    pathname: '/login',
                    state: {
                        from: from?.from || from,
                        email: emailId,
                        passwordRequired: true,
                    },
                });
                message.warning('Please enter your password', TIMEOUT);
            } else {
                setVisible(false);
                from && props.history.push(from?.from || from);
            }
            setLoading(false);
        } else {
            message.error('Please enter email!', TIMEOUT);
        }
    };
    const loginWithPwd = async (e) => {
        e.preventDefault();
        if (password) {
            setLoading(true);
            const auth = await dispatch(
                login({
                    emailId: user.emailId,
                    password,
                    skipLogout: true,
                }),
            );
            if (!auth?.login) {
                message.error(auth.message, TIMEOUT);
            } else {
                setVisible(false);
            }
            setLoading(false);
        } else {
            message.error('Please enter password!', TIMEOUT);
        }
    };
    const forgotPwd = async () => {
        const res = await GlobalApi.forgotPassword({emailId: user.emailId});
        if (res) {
            notification.success({
                message: 'Success',
                description: res.message,
            });
        }
    };
    return (
        <Modal
            title={
                pwdMode ? (
                    <p className="title">
                        Please enter your password for{' '}
                        <span>{user.emailId}</span> to get access to all
                        features
                    </p>
                ) : (
                    <h2>{getWelcomeText()}!</h2>
                )
            }
            visible={isVisible}
            onCancel={() => {
                setVisible(false);
                if (
                    pwdMode &&
                    (location.pathname === '/watchlist' ||
                        location.pathname === '/corporateaccess')
                ) {
                    props.history.push('/landingpage');
                }
            }}
            maskClosable={false}
            wrapClassName={'pro-minus-popup'}
            footer={null}
            centered={window.innerWidth > 1024}
            width={window.innerWidth > 1024 ? 450 : '90%'}
            closeIcon={<img src={closeIcon} alt="close" />}
            maskStyle={{
                background: '#fff0',
            }}
            afterClose={() => {
                const params = new URLSearchParams(location.search);
                params.delete('logincode');
                props.history.replace({search: params.toString()});
                dispatch(setActiveModal(null));
                setPassword('');
                setEmailId('');
            }}
        >
            <form
                className="pro-minus-body"
                onSubmit={(e) => {
                    pwdMode ? loginWithPwd(e) : loginWithCode(e);
                }}
            >
                {pwdMode ? (
                    <>
                        <label htmlFor="password-input" className="label">
                            Enter Password
                        </label>
                        <Input.Password
                            id="password-input"
                            className="password"
                            placeholder="yourpassword"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <div className="CTAs">
                            <Button
                                className="Submit"
                                htmlType="submit"
                                loading={loading}
                            >
                                Login{' '}
                                <img
                                    src={loginIcon}
                                    alt="log in without password"
                                />
                            </Button>
                            <p className="forgot" onClick={forgotPwd}>
                                Forgot password
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <label htmlFor="email-input" className="label">
                            ENTER USER ID / EMAIL
                        </label>
                        <input
                            id="email-input"
                            className="email"
                            type="email"
                            placeholder="youremailid@insights.com"
                            value={emailId}
                            onChange={(e) => setEmailId(e.target.value)}
                        />
                        <div className="CTAs">
                            <Button
                                className="Submit"
                                htmlType="submit"
                                loading={loading}
                            >
                                Log in without password{' '}
                                <img
                                    src={
                                        require('../../assets/images//view-graph-arrow.svg')
                                            .default
                                    }
                                    alt="log in without password"
                                />
                            </Button>
                            <p>Not a DBS Insights Direct user?</p>
                            <div className="flexbox">
                                <Button
                                    onClick={() =>
                                        window.open(
                                            UPGRADE_PLAN_FORM_LINK,
                                            '_blank',
                                        )
                                    }
                                >
                                    Register Now
                                </Button>
                                <Button onClick={() => setVisible(false)}>
                                    Continue as guest
                                </Button>
                            </div>
                        </div>
                    </>
                )}
            </form>
        </Modal>
    );
};
